import axios from 'axios'

export default {
  // ======================================================================
  // ==========================Authentication==============================
  // ======================================================================
  get (context) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/auth/check-user')
        .then(({ data }) => {
          if (data.user) {
            context.commit('SET', data)
            resolve(true)
          } else {
            context.commit('RESET')
            resolve(false)
          }
        }).catch((error) => {
          reject(error)
        })
    })
  },
  signIn (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/auth/login', opts)
        .then(({ data }) => {
          context.commit('SET', data)
          resolve(data)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  signOut (context, opts) {
    context.commit('RESET')
    return new Promise((resolve, reject) => {
      axios
        .post('/api/auth/logout', opts)
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  changeEmail (context, opts) {
    opts.mode = 'change'
    return new Promise((resolve, reject) => {
      axios
        .post('/api/user/token', opts)
        .then(({ data }) => {
          context.commit('SET', { user: data })
          resolve(data)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  confirmEmail (context, opts) {
    opts.mode = 'confirm'
    return new Promise((resolve, reject) => {
      axios
        .post('/api/user/token', opts)
        .then(({ data }) => {
          context.commit('SET', { user: data })
          resolve(data)
        }).catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },
  emailExists (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/auth/check-email', opts)
        .then(({ data }) => {
          resolve(data)
        }).catch((e) => {
          reject(false)
        })
    })
  },
  resetPassword (context, opts) {
    opts.mode = 'reset'
    return new Promise((resolve, reject) => {
      axios
        .post('/api/user/token', opts)
        .then(({ data }) => {
          context.commit('SET', { user: data })
          resolve(data)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  forgotPassword (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/auth/send-reset-email', opts)
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  oauth (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/auth/oauth', opts)
        .then(({ data }) => {
          resolve(data)
        }).catch((e) => {
          reject(false)
        })
    })
  },

  hasOauthLogin (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/auth/has-oauth-login', opts)
        .then(({ data }) => {
          resolve(data)
        }).catch((e) => {
          reject(false)
        })
    })
  },
  // ======================================================================
  // ==========================List Management=============================
  // ======================================================================
  list (context, opts) {
    const options = opts ? { params: opts } : {}
    return new Promise((resolve, reject) => {
      axios
        .get('/api/user', options)
        .then(({ data }) => {
          context.commit('LIST', data)
          resolve(data)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  // ==========================Socket Updates==============================
  created (context, id) {
    axios
      .get(`/api/user/${id}`)
      .then(({ data }) => {
        if (data.id) {
          context.commit('LIST_ADD', data)
        }
      }).catch(() => {
      })
  },
  updated (context, opts) {
    // if this is the logged in user, refresh the whole account
    if (opts === context.state.loggedIn.id) {
      context.dispatch('get')
    }
    // if it's in the list, go fetch its new details
    if (context.state.current.id === opts || context.state.list.find((i) => i.id === opts) !== undefined) {
      axios
        .get(`/api/user/${opts}`)
        .then(({ data }) => {
          if (data.id) {
            context.commit('LIST_UPDATE', data)
            if (data.id === context.state.current.id) {
              context.commit('CURRENT', data)
            }
            if (context.rootState.Group.current.users.length > 0) {
              context.commit('Group/USER_UPDATE', data, { root: true })
            }
          }
        }).catch(() => {
        })
    }
  },
  destroyed (context, opts) {
    // always try to remove from list
    context.commit('LIST_REMOVE', opts)
    if (opts === context.state.current.id) {
      context.commit('CURRENT', null)
    }
  },
  // ===========================List Edits===============================
  add (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/user', opts)
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  update (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`/api/user/${context.state.current.id}`, context.state.update)
        .then(({ data }) => {
          context.dispatch('detail', context.state.current.id)
          resolve(data)
        }).catch((error) => {
          if (error.response && error.response.data && error.response.data.message) {
            reject(error.response.data)
          } else {
            reject(error)
          }
        })
    })
  },
  updateAccount (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .patch('/api/user/edit-account', opts)
        .then(({ data }) => {
          if (data) {
            context.commit('SET', { user: data })
          }
          resolve(data)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  delete (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/user/${opts}`)
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => {
          if (error.response && error.response.data && error.response.data.message) {
            reject(error.response.data)
          } else {
            reject(error)
          }
        })
    })
  },
  detail (context, opts) {
    const id = typeof opts === 'string' ? opts : opts && opts.id ? opts.id : '#'
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/user/${id}`, {
          params: { populate: ['group', 'organization'] }
        })
        .then(({ data }) => {
          context.commit('CURRENT', data)
          resolve(data)
        }).catch((error) => reject(error))
    })
  }
}
